import { render, staticRenderFns } from "./dataSearch.vue?vue&type=template&id=2030a8b4&"
import script from "./dataSearch.vue?vue&type=script&lang=js&"
export * from "./dataSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports